import { getToken } from "firebase/messaging";
import { apiCall } from "../Apis/apiCall";
import { messaging } from "../firebase";
import { VAPIDKEY } from "./Contants";

// Save FCM Token
export  const saveFcmToken = async (userData) => {
    try {
      const currentToken = await getToken(messaging, { vapidKey: VAPIDKEY });
      if (currentToken) {
        const staff_id = userData.staff_id;
        await apiCall("post", "/save/fcm-token", {
          staff_id,
          device_token: currentToken,
          device_type: "web",
        });
      }
    } catch (err) {
      console.error("FCM token error:", err);
    }
  };